import { TextField } from '@andritzot/metris-web-ui/inputs/textfield';
import { type Control, Controller } from 'react-hook-form';

import { type FormProps } from './types';

interface FirstNameFieldProps {
  control: Control<FormProps>;
}

export function FirstNameField({ control }: Readonly<FirstNameFieldProps>) {
  return (
    <Controller
      name="firstName"
      control={control}
      rules={{ required: 'required' }}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          label="First Name"
          required
          fullWidth
          autoComplete="given-name"
          error={!!error}
          helperText={error?.message}
        />
      )}
    />
  );
}
